<template>
	<div class="border px-24 py-16">
		<div class="flex-top">
			<ProfileAvatar :profile="reviewee.profile" size="80" class="mr-16 lg-mr-20 square-80" />
			<div class="pt-4">
				<div class="fs-12 fw-500 color-violet gap-4 flex-top mb-4">
					{{ item.job.event.name }}
					<div class="badge badge-green ml-8 no-shrink">{{ roleName }}</div>
				</div>
				<router-link :to="{ name: $routes.Profile.name, params: { id: reviewee.profile.id } }" class="fs-16 lg-fs-18 fw-700 color-violet hover-blue job-name">{{ reviewee.name }}</router-link>
				<Rating :value="0" class="mt-4"/>
			</div>
		</div>
		
		<!-- Footer -->
		<div class="flex-split pt-16 mt-16 border-top-07">
			<p class="fs-12 pr-16 m0">Completed on <span class="fw-500">{{ date }}</span></p>
			<router-link :to="{ name: $routes.ReviewsCreate.name, query: { jobContractId: item.jobContract.id } }" class="btn btn-green">Leave Review</router-link>
		</div>
	</div>
</template>

<script>
import Role from '@/models/Role';

export default {
	name: 'ItemPendingReview',
	props: {
		item: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
		};
	},
	computed: {
		roleName() {
			return (Role.from(this.item.job.positionId) || Role.missing).name;
		},
		reviewee() {
			return this.item.jobContract.employee;
		},
		date() {
			return this.item.job.event.formattedEventDate.split(',').slice(1).join(', ').trim();
		}
	},
}
</script>
